// Import Enums
import { PermissionEnum } from 'enums';
// Import Components
import SegmentWidget from './SegmentWidget';
import TemplateWidget from './TemplateWidget';
import BonusWidget from './BonusWidget';

const tabsKey = {
    PromoDetails: 'PromoDetails',
    Campaign: 'Campaign',
    Segment: 'Segment',
    Template: 'Template',
    Bonus: 'Bonus',
    ABTest: 'ABTest',
};

const tabsToSwitchKey = {
    [tabsKey.Template]: tabsKey.Bonus,
    [tabsKey.Bonus]: tabsKey.Template,
};

const CampaignTabsConfig = [
    {
        tabKey: tabsKey.Segment,
        buttonContent(selectedRowData) {
            return <SegmentWidget data={selectedRowData} />;
        },
    },
    {
        tabKey: tabsKey.Template,
        buttonContent(selectedRowData) {
            return <TemplateWidget data={selectedRowData} />;
        },
    },
    {
        tabKey: tabsKey.Bonus,
        buttonContent(selectedRowData) {
            return <BonusWidget data={selectedRowData} />;
        },
        permissions: PermissionEnum.ViewAwards,
    },
];

export { tabsKey, tabsToSwitchKey, CampaignTabsConfig };
